// extracted by css-extract-rspack-plugin
export default {"link":"_c122ebe0","tile":"_66a386b4","image":"_49e052a7","socialDropdownWrapper":"_330d5cb3","photoHeartWrapper":"_18c7f7b5"};